export const pageNames = {
    dryDock: 'Dry Dock',
    userSettings: 'User Settings',
    myProjects: 'My Projects',
    createProject: 'Create Project',
    editProject: 'Edit Project',
    summary: 'Summary',
    financialAnalysis: 'Financial Analysis',
    billingExpense: 'Billing & Expenses',
    independence: 'Independence',
    step1EnterProjectDetails: 'Step1:Enter Project Details',
    step2SelectEyCanvasEngagements: 'Step2:Select EY Canvas Engagements',
    step3ManageAccess: 'Step3:Manage Access',
    step4ConnectToMercuryGfis: 'Step4:Connect To Mercury GFIS',
    step5AssociateEngagementCodes: 'Step5:Associate Engagement Codes To EY Canvas Engagements'
};

export const siteSections = {
    dryDock: 'Dry Dock',
    userSettings: 'User Settings',
    projects: 'Projects',
    dashboard: 'Dashboard',
    projectSummary: 'Project Summary',
    createProject: 'Create Project'
};

export const eventTypes = {
	clickAction: 'clickAction',
	pageView: 'pageView'
};

export const clickActionNames = {
    billingExpense: 'Billing & Expenses',
    createProject: 'Create Project',
    createProjectStep1: 'Step 1:Enter Project Details',
    createProjectStep2: 'Step 2:Select EY Canvas Engagements',
    createProjectStep3: 'Step 3:Manage Access',
    createProjectStep4: 'Step 4:Connect To Mercury/GFIS',
    createProjectStep5: 'Step 5:Associate Engagement Codes to EY Canvas Engagements',
    financialAnalysis: 'Financial Analysis',
    independence: 'Independence',
    manageDelegates: 'Manage Delegates',
    privacyNotice: 'Privacy Notice',
    signout: 'Sign Out',
    summary: 'Summary',
    userSettings: 'User Settings',
    financialAnalysis: 'Financial Analysis',
    billingExpense: 'Billing & Expenses',
    independence: 'Independence',
    openProject: 'Open',
    editProject: 'Edit',
    leaveProject: 'Leave',
    deleteProject: 'Delete',
    serviceLine: 'Service Line',
    subServiceLine: 'Sub-Service Line',
    filter: 'Filter',
    rank: 'Rank',
    teamMember: 'Team Member',
    displayServiceLine: 'Display Data By:Service Line',
    displaySubserviceLine: 'Display Data By:Sub Service Line',
    displayRank: 'Display Data By:Rank',
    displayTeamMember: 'Display Data By:Team Member',
    canvasEconomics: 'Canvas Economics',
};

export const controlTypes = {
	button: 'Button',
	dropdown: 'Dropdown',
	toggle: 'Toggle',
	tab: 'Tab',
	icon: 'Icon',
	dragAndDrop: 'Drag & Drop',
	emailLink: 'Email Link',
	checkbox: 'Checkbox',
	calendar: 'Calendar'
};

export const locationInPages = {
    headerRightNav: 'Header:Right Navigation',
    projectSwitcher: 'In Page:Project Switcher',
    topNav: 'In Page:Top Navigation',
    bottomNav: 'In Page:Bottom Navigation',
    projectMenu: 'In Page:Project Menu',
    modalPopup: 'In Page:Modal Pop Up',
    financialAnalysis: 'In Page:Financial Analysis',
    myProjects: 'In Page:My Projects'
};

export const delimiters = [
    ':',
    '-',
    ' ',
    '/',
    '|',
    '_'
];

export const webInteractionTypes = {
    other: "other",
    exit: "exit"
};

export const buttonNames = {
    cancel: 'Cancel',
    continue: 'Continue',
    back: 'Back',
    finish: 'Finish',
    confirm: 'Confirm',
    cancel: 'Cancel'
};

export const filterTypes = {
    filterServiceLine: 'filterserviceline',
    filterSubServiceLine: 'filtersubserviceline',
    filterRank: 'filterrank',
    filterTeamMember: 'filterteammember'
}